import { toast } from 'sonner'

// Regex explanation:
// Matches all {{...}} patterns, even if the content is invalid.
// Ensures it does not greedily capture nested or malformed expressions like {{ {{foo}}.
// The content inside must not include { or }, which prevents accidental over-captures.
export const VARIABLE_HIGHLIGHT_REGEX = /\{\{[^{}]*\}\}/g

// Must be either alphanumeric, hyphens or underscores
const isValidVariable = variable => /^[\w.-]+$/.test(variable)

export function isSafeVariableEdit(newValue, oldValue) {
  const safeNewValue = newValue || ''
  const safeOldValue = oldValue || ''

  // Always allow deletions
  if (safeNewValue.length < safeOldValue.length) {
    return true
  }

  const oldVariables = safeOldValue.match(VARIABLE_HIGHLIGHT_REGEX) || []
  const newVariables = safeNewValue.match(VARIABLE_HIGHLIGHT_REGEX) || []

  for (const newVar of newVariables) {
    const isUnchangedVariable = oldVariables.includes(newVar)

    if (!isUnchangedVariable) {
      // Strip {{ and }}
      const variableName = newVar.slice(2, -2)

      if (!isValidVariable(variableName)) {
        toast.error('Invalid characters: Use only letters, numbers, hyphens or underscores for variables', { id: 'invalid-variable-name' })
        return false
      }
    }
  }

  return true
}
